import React, { useCallback, useEffect, useState } from "react";
import { FaFileImage } from "react-icons/fa";
import { SectionCard, MiniStat } from "../SectionCard";
import { useInView } from "../useInView";
import { fetchOrgExtendAi } from "../api";
import { fmtN, fmtMoney } from "../format";

const ACCENT = "#0891b2";

export default function ExtendAiSection({ organizationId, env, days }) {
  const [ref, inView] = useInView();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const json = await fetchOrgExtendAi(organizationId, env, days);
      setSummary(json?.summary || {});
    } catch (err) {
      setError(err.message || "Failed to load ExtendAI usage");
    } finally {
      setLoading(false);
    }
  }, [organizationId, env, days]);

  useEffect(() => {
    if (inView) load();
  }, [inView, load]);

  const traceCount = summary?.traceCount || 0;

  return (
    <SectionCard
      ref={ref}
      title="ExtendAI OCR"
      subtitle={`Document OCR usage over the last ${days} days`}
      icon={<FaFileImage />}
      accent={ACCENT}
      loading={(loading || !inView) && !summary}
      error={error}
      onRetry={load}
      size="third"
      link={{
        to: `/langfuse-analytics?org=${encodeURIComponent(organizationId)}&env=${env}`,
        label: "Open AI Usage Analytics",
      }}
    >
      {summary && traceCount ? (
        <div className="oo-ministat-row">
          <MiniStat label="OCR runs" value={fmtN(traceCount)} accent={ACCENT} />
          <MiniStat label="Pages" value={fmtN(summary.totalPages)} />
          <MiniStat label="Cost" value={fmtMoney(summary.totalCost)} />
        </div>
      ) : (
        <div className="oo-empty-hint">No ExtendAI OCR activity for this org.</div>
      )}
    </SectionCard>
  );
}
